import { GameHistoryRow } from "@lindar-joy/goosicorn-quickies-library";

 type RouletteColor = 'RED' | 'BLACK' | 'GREEN';

 interface RouletteRound {
  result: number;
  colorResult: RouletteColor;
  engineRoundId: string;
  engineRoundTime: number;
}

 interface RouletteEngineData {
  '@type': 'RouletteEngineData';
  result: RouletteRound;
  lastResults: RouletteRound[];
}

 interface GameAction {
  type: string;       // e.g., "multi-roulette:bet"
  engineRoundId: string;
  selection: RouletteColor | string;
  bet: number;
}

 interface RoulettePayload {
  engineData: RouletteEngineData;
  gameAction: string; // Contains stringified GameAction JSON
}

 export const GameHistoryRenderer = (gameRound: any) => {
    const typedGameRound = gameRound as RoulettePayload;
    return <div>
        <GameHistoryRow style={{display: "none"}}></GameHistoryRow>
        <GameHistoryRow><div>Player Selection</div><div>{ (JSON.parse(typedGameRound.gameAction) as GameAction).selection }</div></GameHistoryRow>
        <GameHistoryRow><div>Game Result</div><div>{ typedGameRound.engineData.result.colorResult }</div></GameHistoryRow>
        </div>
}
